import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  NumberInput,
  NumberInputField,
  FormControl,
  Flex,
  Box,
  ModalFooter,
  FormLabel,
  Input
} from '@chakra-ui/react'
import { ChangeEvent, FC } from 'react'
import { FaTruck } from 'react-icons/fa'
import { FiEdit2 } from 'react-icons/fi'
import { IoIosAddCircle } from 'react-icons/io'

import useReabTypeVeichule from '@hook/parametrization/use-reab-typeveichule'

const ReabTypeVeichuleCreate: FC = () => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const {
    clearParams,
    paramsEdit,
    selected,
    handleUpdateEditParams,
    createData,
    companieId,
    updateDataCurve
  } = useReabTypeVeichule()
  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target

    handleUpdateEditParams({
      name: 'nome',
      value: value
    })
  }

  return (
    <>
      {selected !== 0 ? (
        <Button
          fontSize={14}
          size="sm"
          marginLeft={2}
          leftIcon={<FiEdit2 />}
          colorScheme="green"
          variant="outline"
          onClick={onOpen}
        >
          Editar
        </Button>
      ) : (
        <Button
          fontSize={14}
          size="sm"
          leftIcon={<IoIosAddCircle />}
          colorScheme="blue"
          variant="outline"
          onClick={onOpen}
          isDisabled={companieId === ''}
        >
          Adicionar
        </Button>
      )}
      <Modal
        isCentered
        isOpen={isOpen}
        onClose={() => {
          onClose()
          clearParams()
        }}
        scrollBehavior="inside"
        motionPreset="slideInBottom"
        colorScheme="white"
        size="xl"
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader
            paddingTop={2}
            paddingBottom={2}
            paddingLeft={4}
            paddingRight={4}
            textColor={'gray.200'}
            background={'#1d5840'}
            borderTopLeftRadius={5}
            borderTopRightRadius={5}
            borderBottom="3px solid #ECC94B"
          >
            <Flex>
              <Box p={2}>
                <FaTruck />
              </Box>
              <Box p={2} pt={1} w={1200}>
                {selected !== 0 ? 'Editar Tipo Veículo' : 'Criar Tipo Veículo'}
              </Box>
            </Flex>
          </ModalHeader>

          <ModalCloseButton />
          <ModalBody bg="white" pt={0} py={4}>
            <FormControl isRequired>
              <FormLabel> Nome</FormLabel>
              <Input
                borderBottomColor="black"
                value={paramsEdit.nome}
                onChange={handleInputChange}
              ></Input>
            </FormControl>

            <br></br>
            <FormControl isRequired>
              <FormLabel> Peso Maximo</FormLabel>
              <NumberInput
                borderBottomColor="black"
                value={paramsEdit.pesoMaximo}
                onChange={value =>
                  handleUpdateEditParams({
                    name: 'pesoMaximo',
                    value: value
                  })
                }
              >
                <NumberInputField />
              </NumberInput>
            </FormControl>
            <br></br>
            <FormControl>
              <FormLabel>Custo Fixo </FormLabel>
              <NumberInput
                borderBottomColor="black"
                value={paramsEdit.custoFixo}
                onChange={value =>
                  handleUpdateEditParams({
                    name: 'custoFixo',
                    value: value
                  })
                }
              >
                <NumberInputField />
              </NumberInput>
            </FormControl>
            <br></br>
          </ModalBody>
          <ModalFooter
            bg="white"
            borderBottomLeftRadius={5}
            borderBottomRightRadius={5}
          >
            <Button
              colorScheme="blue"
              mr={3}
              onClick={() => {
                onClose()
                clearParams()
              }}
            >
              Fechar
            </Button>
            <Button
              bg="green.600"
              color="#fff"
              onClick={() => {
                if (selected !== 0) {
                  updateDataCurve()
                  onClose()
                } else {
                  createData()
                  onClose()
                }
              }}
              _hover={{
                bg: 'green.500'
              }}
              _active={{
                bg: 'green.500'
              }}
            >
              Salvar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}

export default ReabTypeVeichuleCreate
